import React, { useEffect } from "react";
import "./marketingAutomation.css";
import bulk_marketing_img1 from "assets/marketingAutomation/bulk_marketing1.jpg";
import bulk_marketing_img2 from "assets/marketingAutomation/bulk_marketing2.jpg";
import bulk_marketing_img3 from "assets/marketingAutomation/bulk_marketing3.png";
import bulk_marketing_img4 from "assets/marketingAutomation/bulk_marketing4.jpg";
import bulk_marketing_img5 from "assets/marketingAutomation/bulk_marketing5.png";
import bulk_marketing_img6 from "assets/marketingAutomation/bulk_marketing6.jpg";
import bulk_marketing_img7 from "assets/marketingAutomation/bulk_marketing7.jpg";
import Meta from "utils/meta";
import SubPageHeader from "Component/SubPageHeader/subPageHeader";
import TextBlock from "Component/TextBlock/textBlock";
import ImageWithTextBlock from "Component/ImageWithTextBlock/imageWithTextBlock";
import FaqBlock from "Component/FaqBlock/faqBlock";

const BulkMarketing = () => {
  const questions = [
    "What is real estate bulk marketing in a CRM?",
    "Which channels are most effective for bulk marketing in real estate?",
    "What types of bulk marketing strategies can be implemented using a CRM?",
    "How does a CRM enhance the effectiveness of bulk email and SMS campaigns?",
  ];
  const answers = [
    "Real estate bulk marketing in a CRM involves sending a large volume of marketing messages, such as emails or SMS, to a targeted list of potential clients. CRM helps automate this process, making it easier to manage and track campaigns and ensuring that the right message reaches the right audience at the right time.",
    [
      "Effective channels for bulk marketing in real estate include:",
      "1:- Email marketing for newsletters and listings.",
      "2:- SMS marketing for quick updates and promotions.",
      "3:- Social media for content sharing and engagement.",
      "4:- Direct mail for targeting specific neighbourhoods.",
      "5:- Automated calls for personalized information about new opportunities and events.",
    ],
    "Using a CRM, real estate professionals can implement bulk marketing strategies such as email campaigns for newsletters and updates, SMS campaigns for quick notifications, and automated social media posts. They can also organize direct mail campaigns, send automated call messages, and manage event invitations for open houses and seminars. Additionally, CRM systems enable segmentation and personalization to tailor messages based on client preferences and behaviour.",
    "A CRM enhances the effectiveness of bulk email and SMS campaigns by automating the process, ensuring timely delivery, and allowing for personalization. It helps segment the audience based on various criteria, ensuring that messages are targeted and relevant. CRMs also track engagement metrics such as open rates, click-through rates, and responses, providing insights to refine future campaigns. Additionally, they can schedule campaigns, manage contact lists, and automate follow-ups, increasing efficiency and effectiveness in reaching potential clients.",
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (<>
      <Meta title="Bulk Marketing | The Realtor Desk" description="" />
        <div className="sub-page--outer">
          <SubPageHeader
              title="Effortless Bulk Marketing with The Realtor Desk"
              subTitle="Realtor Desk makes bulk marketing easy by allowing you to send targeted communications to large audiences with just a few clicks, saving you time and effort."
          />
          <div className="container">
            <TextBlock
                shortTitle=""
                title="Effortless Bulk Marketing with Realtor Desk CRM"
                description="Why burden your sales team with bulk email or SMS marketing? Not only does it drain their energy, but it also impacts their morale. Let Realtor Desk simplify this process, allowing your team to focus on more critical tasks while we handle the bulk marketing efficiently."
                textSize="large"
            />
            <ImageWithTextBlock
                shortTitle="Bulk Email Marketing"
                title="Efficiently Send Emails to a Large Audience"
                description="Email outreach and prospecting can be time-consuming for sales teams. With Realtor Desk, you can effortlessly send emails to a large group of leads—whether segmented or all at once—saving valuable time and resources. This streamlined process allows your sales team to focus on other critical tasks while maintaining consistent communication with prospects."
                image={bulk_marketing_img1}
                imagePosition="right"
            />
            <ImageWithTextBlock
                shortTitle="Email Lists"
                title="Create Custom Lists for Targeted Bulk Communication"
                description="Easily create segmented campaign lists or custom lead lists to send bulk emails and SMS messages. For example, target leads in a specific stage of your sales funnel. Email lists help streamline communication with different lead groups and make it simple to follow up with the same leads, ensuring consistent and effective outreach."
                image={bulk_marketing_img2}
                imagePosition="left"
            />
            <ImageWithTextBlock
                shortTitle="Ensure High-Quality Inbox Delivery"
                title="Guarantee Your Emails Reach Their Intended Audience"
                description="Did you know that nearly a quarter of promotional emails never reach their intended recipients? Realtor Desk ensures high-quality inbox delivery, so you can be confident that your messages are successfully reaching your audience and leads. This reliable delivery helps maximize the effectiveness of your email campaigns."
                image={bulk_marketing_img3}
                imagePosition="right"
            />
            <ImageWithTextBlock
                shortTitle="Bulk Real Estate SMS Marketing CRM"
                title="Send SMS Messages to Leads in Bulk"
                description="A timely SMS can effectively communicate valuable information, send reminders, and foster better engagement. However, sending messages individually to each lead is time-consuming for your sales team. With Realtor Desk, you can send SMS messages in bulk—whether to a specific group of leads or all leads at once—saving time and effort while maintaining effective communication."
                image={bulk_marketing_img4}
                imagePosition="left"
            />
            <ImageWithTextBlock
                shortTitle="Email Compose"
                title="Compose Emails on the Go with Ease"
                description="Our intuitive email builder, featuring customizable templates, gives your sales team the flexibility to compose and edit attractive emails on the fly. This allows for personalized and contextually relevant communication, ensuring that your messages are tailored to the needs of each lead."
                image={bulk_marketing_img5}
                imagePosition="right"
            />
            <ImageWithTextBlock
                shortTitle="Analytics & Reports"
                title="Gain Insights into the Effectiveness of Your Bulk Communication"
                description="Realtor Desk provides detailed reports to track the performance of your bulk email and SMS campaigns, including open rates, click rates, and delivery rates. These insights help you assess the success of your campaigns. Additionally, positive results are factored into your lead scoring, ensuring that the performance of your campaigns directly impacts the prioritization of your leads."
                image={bulk_marketing_img6}
                imagePosition="left"
            />
            <ImageWithTextBlock
                shortTitle="Remarket to Segmented Audience on Facebook & Google"
                title="Leverage Lead Data for Targeted Remarketing Campaigns"
                description="Utilize your segmented lead data to run highly targeted remarketing campaigns on Facebook and Google. By delivering contextualized ads, you can effectively engage leads and encourage them to re-enter your pipeline, increasing the likelihood of conversion and driving more meaningful interactions."
                image={bulk_marketing_img7}
                imagePosition="right"
            />
            <FaqBlock
                questions={questions}
                answers={answers}
            />
          </div>
      </div>
    </>
  );
};

export default BulkMarketing;
